import { Trees, Waves, Bed, Users, Check, Bus } from "lucide-react";
import riverBeachPropertyImage from "@/assets/river-beach-property.webp";
import uncrowdedRiverImage from "@/assets/uncrowded-river-tubing.webp";
import glampingInteriorImage from "@/assets/glamping-interior-comfort.webp";
import familyAtmosphereImage from "@/assets/family-atmosphere.webp";
import everythingIncludedImage from "@/assets/everything-included.webp";
import shuttleServiceImage from "@/assets/shuttle-service.webp";

const WhyChooseUsSection = () => {
  const features = [
    {
      icon: Trees,
      title: "8 Private Acres",
      description: "Room to spread out. Your family won't feel packed in like sardines.",
      image: riverBeachPropertyImage,
    },
    {
      icon: Waves,
      title: "Uncrowded River",
      description: "Float 1.5 miles without bumping into strangers. This isn't downtown New Braunfels.",
      image: uncrowdedRiverImage,
      imagePosition: "object-[center_65%]",
    },
    {
      icon: Bed,
      title: "Real Comfort",
      description: "AC cabins, clean bathrooms, shaded spots. Glamping means no suffering.",
      image: glampingInteriorImage,
    },
    {
      icon: Users,
      title: "Family Atmosphere",
      description: "No rowdy party crowds. Just family and friend groups who respect each other.",
      image: familyAtmosphereImage,
      imagePosition: "object-top",
    },
    {
      icon: Check,
      title: "Everything You Want",
      description: "Transparent pricing. Your cabin & cabana comes with grill, hammock, seating — no nickel-and-diming.",
      image: everythingIncludedImage,
    },
    {
      icon: Bus,
      title: "Shuttle Service",
      description: "We own the put-in AND take-out. Hop on a tube or kayak and we'll handle the rest.",
      image: shuttleServiceImage,
    },
  ];

  return (
    <section className="py-24 bg-river-gradient">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown mb-4">
            What Makes Son's Blue River Camp <span className="text-white">Different</span>
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={feature.title}
              className="group bg-card rounded-2xl overflow-hidden shadow-soft hover:shadow-elevated transition-all duration-500 border border-border hover:border-river/30"
            >
              {feature.image && (
                <div className="h-52 overflow-hidden">
                  <img 
                    src={feature.image} 
                    alt={feature.title}
                    className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ${feature.imagePosition || ''}`}
                    loading="lazy"
                    decoding="async"
                    width={400}
                    height={208}
                  />
                </div>
              )}
              <div className="p-6 text-center">
                <div className="flex items-center justify-center gap-4 mb-3">
                  <div className="w-10 h-10 rounded-xl bg-river/10 flex items-center justify-center shrink-0 group-hover:bg-river/20 transition-colors">
                    <feature.icon className="h-5 w-5 text-river" />
                  </div>
                  <h3 className="font-heading text-xl font-semibold text-foreground">
                    {feature.title}
                  </h3>
                </div>
                <p className="text-muted-foreground leading-relaxed mx-auto max-w-[90%]">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
